import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Icon, IconButton, Scrollbar, Typography } from 'shared/ui'
import { type RecentSearchesStore } from 'pages/conversations/pages/search/ui/RecentSearches'
import styles from './styles.module.scss'

type IRecentSearchesProps = {
  store: RecentSearchesStore
}

export const RecentSearches: FC<IRecentSearchesProps> = observer(({ store }) => {
  const { items, removeItem, setSearch } = store

  if (!items.length) return null

  return (
    <div className={styles.wrap}>
      <Typography ariaLabel={'recent'} variant={'button-medium'} className={styles.label}>
        Recent searches
      </Typography>
      <Scrollbar>
        <div className={styles.list}>
          {items.map((result) => (
            <div className={styles.item} key={result.id}>
              <div className={styles.box}>
                <Icon icon={'search'} tertiary />
              </div>
              <Typography
                ariaLabel={'title'}
                variant={'body-md-regular'}
                className={styles.title}
                onClick={() => {
                  setSearch(result.term, true)
                }}
              >
                {result.term}
              </Typography>
              <div className={styles.close}>
                <IconButton
                  ariaLabel={'remove'}
                  icon={'close'}
                  variant={'icon'}
                  color={'tertiary'}
                  size={'small'}
                  onClick={() => removeItem(result.id)}
                />
              </div>
            </div>
          ))}
        </div>
      </Scrollbar>
    </div>
  )
})
